import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import vuetify from "./plugins/vuetify";
import router from "./router/router";

import * as VueGoogleMaps from "gmap-vue";
import GmapCustomMarker from "vue2-gmap-custom-marker";

import mixins from "@/mixins";
import { i18n } from "@/plugins/i18n";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDUVfehwMbqiwm4HElOZjOMky6qw8GeU6g",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then disable the following:
  // installComponents: true,
});

Vue.component("GmapCustomMarker", GmapCustomMarker);
Vue.mixin(mixins);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
